module.exports = __webpack_public_path__ + "img/DP058E&DP058G.ab370da7.png";